/**
 * /it-act — Income Tax Act 1961 → 2025 explorer.
 *
 * Sits under the protected layout (auth required) and shares the global nav.
 * Imports the `SectionMapper` feature component which handles search,
 * filtering, and the card list internally.
 */
import { createFileRoute } from '@tanstack/react-router';
import { SectionMapper } from '@/features/it-act/components/section-mapper';

export const Route = createFileRoute('/_protected/it-act')({
  component: IncomeTaxActPage,
});

function IncomeTaxActPage() {
  return <SectionMapper />;
}
